module.exports = __webpack_public_path__ + "img/ebi_banner.3c357a12.jpg";